const initialState = {
    loading: false,
    error: '',
}

const CmsHome = (state = initialState, action) => {
    switch(action.type){
        case 'LOADING':
            return {
                ...state,
                loading: action.payload
            }
        
        default: return state
    }
}

export default CmsHome